import defaultStore from "./defaultStore";
import {teaStore} from "@/tea/store";
import domain from "@/utils/appDomain";

const store = domain.isTea ? teaStore : defaultStore;
export default store;
